import * as React from "react"

function SvgDessert(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 24 24" fill="none" {...props}>
      <path
        d="M12.97 4.74L2.72 13.39c.14-.07.28-.12.44-.15l15.36-2.99c-1.84-4.24-5.55-5.51-5.55-5.51z"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M18.82 11.01a8.58 8.58 0 00-.3-.76L3.16 13.24c-.16.03-.3.08-.44.15l-.01.01c-.42.23-.69.68-.69 1.19v3.85h15.36c1.04 0 1.88-.84 1.88-1.88v-2.63c0-.99-.12-1.98-.44-2.92z"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.75 5.79c-1.82-2.3-3.82-3.3-5.46-3.71-1.69-.42-3.32.9-3.32 2.64v.02s3.71 1.27 5.55 5.51c.08.17.15.34.21.52-.28-1.92 1.75-2.8 2.6-3.2a1.172 1.172 0 00.42-1.78z"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21.33 7.57c-.85.4-2.88 1.28-2.6 3.2v.01c.04.08.06.15.09.23.32.94.44 1.93.44 2.92v2.63c0 1.04-.84 1.88-1.88 1.88H2v2.35c0 .67.54 1.21 1.21 1.21h15.37c1.89 0 3.42-1.53 3.42-3.42V6.5c0 .44-.24.87-.67 1.07z"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M10.62 14.82c1.07-.15 1.23 1.02 2.3.87 1.07-.15.91-1.32 1.98-1.47 1.07-.15 1.23 1.02 2.31.87 1.07-.15.99-1.32 2.06-1.47"
        stroke="currentColor"
        strokeWidth={2}
        strokeMiterlimit={10}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  )
}

export default SvgDessert
